<div class="equis" (click)="onCancel()">X</div>
<h1 class="mall-title">Conferencia</h1>
<div class="mall-line"></div>
<div class="mall-desc">
  Coloca un nombre y una descripción a tu evento
</div>

<div class="form-container">
  <form [formGroup]="eventoForm">
    <div class="campos">
      <mat-form-field appearance="legacy" class="nombre-evento">
        <mat-label>Nombre del evento</mat-label>
        <mat-icon matPrefix>panorama_fish_eye</mat-icon>
        <input matInput type="text" formControlName="nombre_evento" />
      </mat-form-field>
      <mat-form-field appearance="legacy" class="desc-evento">
        <mat-label>Descripción del evento</mat-label>
        <mat-icon matPrefix>panorama_fish_eye</mat-icon>
        <textarea
          matInput
          name=""
          id=""
          formControlName="descripcion_evento"
        ></textarea>
      </mat-form-field>
      <div *ngIf="!creating" class="botones">
        <button (click)="onCancel()" mat-button class="btn btn-cancelar">
          Cancelar
        </button>
        <button
          (click)="createEvent(eventoForm.value)"
          mat-button
          class="btn btn-continuar"
        >
          Continuar
        </button>
      </div>

      <!-- <p *ngIf="creating">Creando...!</p> -->
      <p class="disponible-en" *ngIf="creating">
        Tu evento estará disponible en:
      </p>
      <p id="countDown" *ngIf="creating"></p>
      <p class="no-cerrar" *ngIf="creating">
        No cierres esta ventana hasta que no finalice el conteo!
      </p>

      <br />
      <br />
      <div class="video-container" *ngIf="creating">
        <iframe
          width="560"
          height="315"
          src="https://www.youtube.com/embed/NYOMLIE3fSU?autoplay=1&"
          title="YouTube video player"
          frameborder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowfullscreen
        ></iframe>
      </div>
    </div>
  </form>
</div>

<div class="row cards"></div>
